var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('roomInfoScreen',{attrs:{"smile":true,"home_button":true}},[_vm._v("\n  Thank you for starting your subscription\n")])}
var staticRenderFns = []

export { render, staticRenderFns }